import React, { Component } from "react";
import PropTypes from "prop-types";
import { includes } from "lodash";
import Toggle from "material-ui/Toggle";
import IconButton from "material-ui/IconButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";

import { DivHeaderActions, DivTitle } from "./styled";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { UploadImage } from "../../../components";
import {
  BlockCounter,
  Counter,
  transitionsAnimation,
  DialogAnimation,
  Alignment,
  TextInput
} from "./components";
// import transitions from 'material-ui/styles/transitions';

const defaultHref = {
  url: "",
  target: "",
  isCollection: false,
  collection: 0
};

const itemsAnimationDirection = [];
for (let i = 0; i < transitionsAnimation.length; i++) {
  const item = transitionsAnimation[i];
  itemsAnimationDirection.push(
    <MenuItem value={item.value} key={i} primaryText={item.text} />
  );
}

class ImageView extends Component {
  constructor(props) {
    super(props);
    const {
      containerPadding,
      align,
      width,
      imageUrl,
      altText,
      animation,
      href
    } = props.data.values;
    let widthType = "%";
    let widthValue = width ? width.split("%").join("") * 1 : 100;
    if (includes(width, "px")) {
      widthValue = width ? width.split("px").join("") * 1 : 100;
      widthType = "px";
    }
    this.state = {
      isEditMode: false,
      expanded: true,
      align: align,
      imageUrl: imageUrl,
      altText: altText,
      containerPadding: containerPadding,
      width: widthValue,
      type: widthType,
      maxValueWidth: widthType === "px" ? 0 : 100,
      interval: widthType === "px" ? 20 : 1,
      animation: animation || {
        direction: "fade",
        show: false,
        duration: 1000,
        type: "ease both"
      },
      href: href || defaultHref
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.align = this.state.align;
    newData.values.altText = this.state.altText;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.width = this.state.width + this.state.type;
    newData.values.imageUrl = this.state.imageUrl;
    newData.values.animation = this.state.animation;
    newData.values.href = this.state.href;
    this.props.onUpdateData(newData);
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };

  onChangeAlign = value => {
    this.setState({ align: value });
  };

  onToggleShowAnimation = (e, v) => {
    let newAnimation = this.state.animation;
    newAnimation.show = v;
    this.setState({ animation: newAnimation });
  };

  onUpdateUrl = value => {
    this.setState({ imageUrl: value });
  };
  onUpdateHrefUrl = value => {
    let newHref = this.state.href;
    newHref.url = value;

    this.setState({
      href: newHref
    });
  };
  onChangeTarget = (event, index, value) => {
    const newValue = value === "_blank" ? value : "";
    let newHref = this.state.href;
    newHref.target = newValue;
    this.setState({
      href: newHref
    });
  };
  onUpdateAltText = value => {
    this.setState({ altText: value });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.align = this.state.align;
    newData.values.altText = this.state.altText;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.width = this.state.width + this.state.type;
    newData.values.imageUrl = this.state.imageUrl;
    newData.values.animation = this.state.animation;
    newData.values.href = this.state.href;
    localStorage.setItem("ImageView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const imageContent = JSON.parse(localStorage.getItem("ImageView"));
    if (imageContent) {
      const {
        containerPadding,
        align,
        width,
        imageUrl,
        altText,
        animation,
        href
      } = imageContent;
      let widthType = "%";
      let widthValue = width ? width.split("%").join("") * 1 : 100;
      if (includes(width, "px")) {
        widthValue = width ? width.split("px").join("") * 1 : 100;
        widthType = "px";
      }
      this.setState({
        align: align,
        imageUrl: imageUrl,
        altText: altText,
        containerPadding: containerPadding,
        width: widthValue,
        type: widthType,
        animation: animation || {
          direction: "fade",
          show: false,
          duration: 1000,
          type: "ease both"
        },
        href: href || defaultHref
      });
    }
  };
  onDuration = value => {
    const animation = this.state.animation;
    animation.duration = value;
    this.setState({ animation });
  };

  handleChange = (event, index, value) => {
    const item = transitionsAnimation[index];
    const animation = this.state.animation;
    animation.direction = value;
    animation.type = item.animation;
    this.setState({ animation });
  };
  onSelectedAnimation = anim => {
    const animation = this.state.animation;
    animation.direction = anim.value;
    animation.type = anim.animation;
    this.setState({ animation });
  };
  onSetValue = (key, value) => {
    this.setState({ width: value });
  };
  onChangeType = (event, value) => {
    let width = 0;
    let content = this.state.width;
    let interval = 20;
    if (value === "%") {
      width = 100;
      content = 100;
      interval = 1;
    }
    this.setState({
      type: value,
      maxValueWidth: width,
      width: content,
      interval: interval
    });
  };
  render() {
    const { type } = this.props.data.values;
    const { target } = this.state.href;
    const valueTarget = target === "_blank" ? target : "same";
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Image"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              style={{ overflowY: "scroll", height: 500 }}
              expandable={true}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Upload Image</DivTitle>
                <UploadImage
                  type={type}
                  imageUrl={this.state.imageUrl}
                  onUpdateUrl={value => this.onUpdateUrl(value)}
                  title="Image"
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={containerPadding =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
              </Paper>

              <Paper style={{ padding: 10 }} zDepth={1}>
                <DivTitle> Width</DivTitle>
                <RadioButtonGroup
                  name="imagewidth"
                  valueSelected={this.state.type}
                  onChange={this.onChangeType}
                  style={styles.radioGroup}
                >
                  <RadioButton
                    value="%"
                    label="Percent"
                    style={styles.radioButton}
                  />
                  <RadioButton
                    value="px"
                    label="Pixel"
                    style={styles.radioButton}
                  />
                </RadioButtonGroup>
                <Counter
                  isDisabled={false}
                  onSetValue={value => this.onSetValue("Width", value)}
                  value={this.state.width}
                  interval={1}
                  maxValue={this.state.maxValueWidth}
                />
              </Paper>

              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Alignment</DivTitle>
                <Alignment
                  value={this.state.align}
                  onChange={value => this.onChangeAlign(value)}
                  title=""
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Animation Direction</DivTitle>
                <SelectField
                  value={this.state.animation.direction}
                  onChange={this.handleChange}
                  maxHeight={200}
                >
                  {itemsAnimationDirection}
                </SelectField>
                <DialogAnimation
                  onItemSelected={value => this.onSelectedAnimation(value)}
                />
                <div>
                  <Counter
                    isDisabled={false}
                    title="Duration"
                    onSetValue={value => this.onDuration(value)}
                    value={this.state.animation.duration}
                    interval={1}
                    subtitle="ms"
                    minValue={100}
                  />
                </div>
                <div>
                  <Toggle
                    label="Show"
                    style={{ marginTop: 10 }}
                    toggled={this.state.animation.show}
                    onToggle={(e, v) => this.onToggleShowAnimation(e, v)}
                  />
                </div>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Action</DivTitle>
                <SelectField
                  floatingLabelText="Target"
                  onChange={(event, index, value) =>
                    this.onChangeTarget(event, index, value)
                  }
                  value={valueTarget}
                  autoWidth={true}
                  name="target href"
                >
                  <MenuItem value={"same"} primaryText="Same Page" />
                  <MenuItem value={"_blank"} primaryText="New Page" />
                </SelectField>
                <TextInput
                  value={this.state.href.url}
                  onChange={value => this.onUpdateHrefUrl(value)}
                  name="HrefUrl"
                  title="Url"
                  fullWidth={true}
                />
              </Paper>
              {/* <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Alternatif Text</DivTitle>
                <TextInput value={this.state.altText} onChange={(value) => this.onUpdateAltText(value)} title=""/>
              </Paper> */}
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 60
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

ImageView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

ImageView.defaultProps = {
  data: {}
};
export default ImageView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/ImageView.js